import { render, staticRenderFns } from "./veJkyResource.vue?vue&type=template&id=e31276c0&scoped=true"
import script from "./veJkyResource.vue?vue&type=script&lang=js"
export * from "./veJkyResource.vue?vue&type=script&lang=js"
import style0 from "./veJkyResource.vue?vue&type=style&index=0&id=e31276c0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e31276c0",
  null
  
)

export default component.exports